import { ActionSequence } from 'src/lib/ActionSequence';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import StateObserver from 'src/StateObserver';
import features from 'src/replicant/ruleset/features';
import { getTutorialController } from '../tutorial/TutorialController';
import { isPlatformGuest } from '../../lib/utils';
import platform from '@play-co/gcinstant';

export async function openProfile() {
  // Feature disabled, bail.
  if (!features(StateObserver.getState().user).ingameProfile) {
    return;
  }

  await ActionSequence.start(
    [
      async () => {
        // Await for tutorial to be completed.
        await getTutorialController().handleEvent('profilePopupOpened');
        return false;
      },

      async () => {
        // No public profile yet, should create one.
        const {
          user: { publicProfile },
        } = StateObserver.getState();

        if (!publicProfile) {
          return await openPopupPromise('popupEditProfile', {
            hideCloseButton: true,
          });
        }

        return false;
      },
      async () => {
        await openPopupPromise('popupProfile', {});
        return false;
      },
    ],
    'OpenProfile',
  );
}
